import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './common/navbar/navbar.component';
import { HeaderComponent } from './common/header/header.component';
import { ShService } from './services/sh-service';
import { ApiDataService } from './services/api.service';
import { ReLoginComponent } from './shared/re-login/re-login.component';
import { WebVitalsService } from './services/vital.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NavbarComponent, HeaderComponent, ReLoginComponent, CommonModule],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  isLoggedIn: any;
  org: string = '';
  orgList: any;
  currentProfile: number = -1;
  timer: any;
  sessionExpWarning: boolean = false;
  labelLoaded: boolean = true;
  currentLob: string = '';
  lastAliveAt: any;
  now: any;
  @ViewChild('audioOption') audioPlayerRef!: ElementRef;
  metrics: any = {};
  // Idle timeout configuration (in minutes)
  IDLE_TIMEOUT: number = 0; 
  WARNING_TIME: number = 0; 

  // Track last activity
  lastActivityTime: number = Date.now();
  idleCheckInterval: any;
  private warningShown: boolean = false;

  constructor(
    private _service: ShService,
    private _apiService: ApiDataService,
    private webVitalsService: WebVitalsService
  ){
    this.IDLE_TIMEOUT = parseInt(sessionStorage.getItem('timeout') as any) - 1
    this.WARNING_TIME = this.IDLE_TIMEOUT - 1;
  }

  ngOnInit(): void {
    this.metrics = this.webVitalsService.getMetrics();
    this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');
    sessionStorage.getItem("email")? this._service.isLoggedIn$.next(true) : null;
    this._service.isLoggedIn$.subscribe(x => {
      this.isLoggedIn = x;
      if(this.isLoggedIn){
        this.initializeIdleTimeout();
        this.org = sessionStorage.getItem('org') || '';
        setTimeout(() => {
          this.currentLob = sessionStorage.getItem('currentLob') || '';
          this.getData(); 
        }, 10);
      }
    });

    this._service.isLabelLoaded$.subscribe(x => {
      x? this.labelLoaded = true : null;
      setTimeout(() => {
        this.org = sessionStorage.getItem('org') || '';
        this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');
        if(this.currentProfile === 1 || this.currentProfile === 2){
          this.getThreePLInfo(this.org)
        }
        else{
          this._service.orgInfo$.next(null);
        }
      }, 100);
    });

    if(this.currentProfile === 1 || this.currentProfile === 2){
      this.getThreePLInfo(this.org)
    }
    else{
      this._service.orgInfo$.next(null);
    }

    this._service.init.subscribe(() => {
      this.resetIdleTimer()
    });
  }

    private initializeIdleTimeout(): void {
    // Reset on user activity
    //this.setupActivityListeners();

    // Check idle status every 10 seconds
    this.idleCheckInterval = setInterval(() => {
      this.checkIdleStatus();
    }, 10000);

    // Handle tab visibility - recalculate when tab becomes visible
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.checkIdleStatus(); // Recalculate immediately when tab comes back
      }
    });
  }

  private resetIdleTimer(): void {
    this.lastActivityTime = Date.now();
    this.warningShown = false; // Reset warning flag
  }

  private checkIdleStatus(): void {
    if (!this.isLoggedIn) return;

    const elapsedMinutes = (Date.now() - this.lastActivityTime) / 1000 / 60;

    // Show warning at 59 minutes
    if (elapsedMinutes >= this.WARNING_TIME && !this.warningShown) {
      this.warningShown = true;
      this.sessionExpWarning = true;
    }
  }

  getData(){
    this._apiService.getOrg(this.currentLob).subscribe(x => {
      this.orgList = x;
      this.orgList.filter((x: any) => {
        x.selected = true;
        x.orgs.filter((y: any) => y.selected = true);
      });
      sessionStorage.setItem('orgList', JSON.stringify(this.orgList));
      setTimeout(() => {
        this._service.orgListTouched$.next(true);
      }, 500);
    })
  }

  toggleReAuth(ev: any){
    this.sessionExpWarning = !ev;
  }

  getThreePLInfo(org: string){
    this._apiService.getThreePLInfo(org).subscribe({
      next: (res) => {
        res.managerContact = res.managerContact? res.managerContact.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : null;
        this._service.orgInfo$.next(res);
      },
      error: (err) => {
        this._service.orgInfo$.next(null);
      }
    });
  }

    ngOnDestroy(): void {
    if (this.idleCheckInterval) {
      clearInterval(this.idleCheckInterval);
    }
  }
}